import { useEffect, useCallback } from 'react';
import { selectors, getAll, addItem, updateItem, deleteItem } from '../../../redux/companyShipAccounts';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import useCouriers from './useCouriers';

export default function useCompanyShipAccount() {
    const dispatch = useDispatch();
    const reduxState = useSelector(state => state.companyShipAccounts);
    const items = selectors.selectAll(reduxState);
    const loading = reduxState.loading;
    const couriers = useCouriers();

    useEffect(() => {
        dispatch(getAll());
    }, [dispatch]);

    const save = useCallback((item) => {
        const updateCall = async () => {
            if (item.third_party_account_id) {
                await dispatch(updateItem({ id: item.third_party_account_id, ...item }));
            } else {
                await dispatch(addItem({ ...item, ordering: items.length }));
            }
            toast.success("Saved successfully");
        };

        updateCall();
    }, [dispatch, items.length]);

    const remove = useCallback((item) => {
        const deleteCall = async () => {
            await dispatch(deleteItem(item));
            toast.success("Deleted successfully");
        };

        deleteCall();
    }, [dispatch]);

    return [
        items,
        loading,
        save,
        remove,
        couriers,
    ];
};
